import axios from "axios";

const baseURL = 'http://18.134.133.59:4000/api/v1.0';

export const fetchBranchList = async () => {
    const { data } = await axios.get(`${baseURL}/branch-list`);
    const branches = data.map(branch=>{
        return {
            name: branch.branch_name,
            address: branch.address,
            code: branch.branch_code,
            bank: branch.bank_name,
            state: branch.state,
            zone: branch.zone,
        }
    })

    return branches;

}